var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350 -232)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(-350 232)",
    fill: "#dae0e7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-340.11 243.875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.188 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.173 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    fill: "#0d1b4b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-319,271.879l-15.189-15.189-2.121,2.121L-321.121,274H-319Z",
    transform: "translate(336.311 -247.715)",
    fill: "#0d1b4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-327.647,249.715h17.526v-2h-19.526v10.69l2,2Z",
    transform: "translate(336.311 -247.715)",
    fill: "#0d1b4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-308.124,261.714V276.98h-19.523V270.3l-2-2V278.98h23.523V261.714Z",
    transform: "translate(336.311 -247.715)",
    fill: "#0d1b4b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.cff6aea7f7d663a928205dea556a5797.svg";
export { ForwardRef as ReactComponent };